export default __webpack_public_path__ + "static/media/logout.5536019d.svg";